import React, { FC, useContext } from 'react';
import { NolPromotionStoreCtx } from '@/stores/NolPromotionStore';
import NolNoticeBottomSheet from '../NolNoticeBottomSheet';
import { observer } from 'mobx-react-lite';
import styles from './index.module.scss';

interface NolCardFlightOffersBottomSheetProps {}

/** 현대 NOL 카드 특가 일본/중국/동남아 항공권 즉시 할인 */
const NolCardFlightOffersBottomSheet: FC<NolCardFlightOffersBottomSheetProps> = () => {
  const store = useContext(NolPromotionStoreCtx);
  return (
    <NolNoticeBottomSheet
      title={<div className={styles.title}>NOL 카드 특가 항공권 유의사항</div>}
      isOpen={store.isNolCardFlightOffersBottomSheetOpen}
      onRequestClose={() => (store.isNolCardFlightOffersBottomSheetOpen = false)}
    >
      <ul>
        <li>본 프로모션은 NOL 앱/웹에서의 예약 및 결제 건에 대해서만 적용됩니다.</li>
        <li>
          프로모션 대상 좌석이 소진된 경우, 본 프로모션 대상 상품의 구매 페이지 내 항공권 판매가가 안내된
          할인가(최종가)와 다르게 나타날 수 있습니다.
        </li>
        <li>항공권 발급 시 발권대행 수수료가 별도 부과되며 발권대행 수수료에는 할인이 적용되지 않습니다.</li>
        <li>할인가(최종가)는 TAX/유류할증료가 포함된 최종 요금입니다.</li>
        <li>NOL 카드 항공권 특가 프로모션 적용 시 타 이벤트 및 쿠폰 등의 중복 할인이 불가합니다.</li>
        <li>
          본 프로모션은 장애/경로 등의 특별운임 및 국내 항공권, 편도 항공권, 땡처리 항공권 등에는 적용되지 않습니다.
        </li>
        <li>
          <u>
            이벤트 혜택(포인트, 캐시백, 쿠폰 등)을 제공받은 달부터 13개월 내 대상 카드 해지 또는 탈회 시 받은 혜택은
            현금으로 청구되거나, 등록된 본인 명의 결제 계좌에서 자동 출금될 수 있음 (예시 : 2025년 8월에 혜택을 제공받은
            후, 2026년 8월 31일 이전에 대상 카드 해지 또는 탈회 시 제공받은 혜택 금액만큼 청구)
          </u>
        </li>
        <li>
          위 프로모션 혜택을 받고자 하실 경우 NOL 회원으로 가입하여야 하며, 본인인증 회원 본인에 한해 혜택이 제공됩니다.
        </li>
        <li>
          혜택 제공 시점에 대상 카드 해지, 분실, 교체(재발급 등), 정지(연체 등) 등의 경우 혜택이 제공되지 않습니다.
          <br />
          (카드 상태가 정상인 경우에 한해 제공)
        </li>
        <li>
          실물카드가 없는 경우 발권수수료를 포함한 총 결제금액 300만원 이상 결제 시 결제가 정상적으로 진행되지 않을 수
          있으며, 결제되지 않은 일부 금액에 대해 추가 청구될 수 있습니다.
        </li>
        <li>
          혜택 제공월 포함 12개월 내 이벤트 채널에 관계없이 현대카드의 다른 이벤트 혜택(캐시백, 포인트, 할인 쿠폰 등)을
          받은 이력이 있는 경우, 조건을 충족하더라도 혜택 제외
        </li>
        <li>본 이벤트는 당사 또는 제휴사 사정에 의해 변경 또는 중단될 수 있습니다. </li>
      </ul>
    </NolNoticeBottomSheet>
  );
};

export default observer(NolCardFlightOffersBottomSheet);
